import * as randomstring from 'randomstring';
import { NotificationAction } from '@pushly/models/lib/structs/notification-action';
import { NotificationActionType } from '@pushly/models/lib/enums/notification-action-type';
import { DEFAULT_NOTIFICATION_ACTION_CLOSE_LABEL, DEFAULT_NOTIFICATION_ACTION_OPEN_URL_LABEL } from '../constants';
import clone from 'clone-deep';
import isValidDomain from 'is-valid-domain';
import isValidHostname from 'is-valid-hostname';
// Utility Functions
export function getDomainDefaultActionLabels(domain) {
  var defaultOpenUrlLabel = DEFAULT_NOTIFICATION_ACTION_OPEN_URL_LABEL;
  var defaultCloseUrlLabel = DEFAULT_NOTIFICATION_ACTION_CLOSE_LABEL;

  if (domain.defaultNotificationActionLabels) {
    defaultOpenUrlLabel = domain.defaultNotificationActionLabels.openUrl || DEFAULT_NOTIFICATION_ACTION_OPEN_URL_LABEL;
    defaultCloseUrlLabel = domain.defaultNotificationActionLabels.close || DEFAULT_NOTIFICATION_ACTION_CLOSE_LABEL;
  }

  return {
    openUrl: defaultOpenUrlLabel,
    close: defaultCloseUrlLabel
  };
}
export function getNotificationActionOrDefault(domain, ordinal, actionsOverride) {
  var _ref, _domain$defaultNotifi, _domain$defaultNotifi2;

  var defaultActions = (_ref = actionsOverride !== null && actionsOverride !== void 0 ? actionsOverride : domain === null || domain === void 0 ? void 0 : domain.defaultNotificationActions) !== null && _ref !== void 0 ? _ref : [];
  var defaultOpenUrlLabel = (_domain$defaultNotifi = domain === null || domain === void 0 ? void 0 : (_domain$defaultNotifi2 = domain.defaultNotificationActionLabels) === null || _domain$defaultNotifi2 === void 0 ? void 0 : _domain$defaultNotifi2.openUrl) !== null && _domain$defaultNotifi !== void 0 ? _domain$defaultNotifi : DEFAULT_NOTIFICATION_ACTION_OPEN_URL_LABEL;
  var action = defaultActions.find(function (a) {
    return a.ordinal === ordinal;
  });

  if (ordinal === 0 && !action) {
    // default action should be determined if secondary exists or not for ordinal 0
    var secondaryAction = defaultActions.find(function (a) {
      return a.ordinal === 1;
    });
    action = {
      ordinal: 0,
      type: NotificationActionType.OPEN_URL,
      label: defaultOpenUrlLabel,
      usePrimaryLandingUrl: secondaryAction ? !secondaryAction.usePrimaryLandingUrl : true
    };
  }

  if (!action) {
    return undefined;
  }

  return NotificationAction.Builder.setOrdinal(action.ordinal).setType(action.type).setLabel(action.label).setLandingUrl(action.landingUrl).setUsePrimaryLandingUrl(action.usePrimaryLandingUrl).setDisplayMeta({
    eid: randomstring.generate()
  });
}
export function prepareDomainAllowList(domains, allowSubdomainWildcards) {
  var _domains;

  domains = (_domains = domains) !== null && _domains !== void 0 ? _domains : [];
  var testDomains = clone(domains);

  if (allowSubdomainWildcards) {
    testDomains = testDomains.map(function (domainStr) {
      return domainStr.replace(/^\*\./, '');
    });
  }

  if (Array.isArray(testDomains) && testDomains.length > 0) {
    var invalidDomainMatch = testDomains.some(function (domainStr) {
      return !(isValidHostname(domainStr) || isValidDomain(domainStr));
    });

    if (invalidDomainMatch) {
      throw {
        whitelistDomains: {
          errors: [{
            message: 'Allow List domains must be valid domain names or IP addresses containing no special characters.'
          }]
        }
      };
    }
  }

  return domains;
}